import React from 'react';

// Najdar Stays Page Content
export const najdarStaysContent = {
  pageMaxWidth: '1200px',
  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },
  sections: [
    // 🏠 HERO SECTION
    {
      id: 'hero',
      spacing: 'clamp(32px, 5vw, 64px)',
      blocks: [
        { type: 'title', text: 'Najdar Stays', size: 'h1' },
        { type: 'text', content: 'Light Website for Airbnb Hosting – Guiding Guests', size: 'large', align: 'center' },
        { type: 'spacer', size: 'small' },
        { type: 'button', text: 'Preview Site', url: '/projects/najdar-stays', style: 'primary', size: 'large' }
      ]
    },

    // 📖 OVERVIEW
    {
      id: 'overview',
      title: 'Overview',
      blocks: [
        {
          type: 'text',
          content: 'A soft, responsive website designed to introduce the apartment to guests and guide them through everything they need for a seamless stay—from check-in instructions and house rules to local recommendations and support contacts.',
          size: 'normal',
          align: 'left'
        }
      ]
    },

    // ⭐ FEATURES
    {
      id: 'features',
      title: 'Key Features',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <ul style={{
              color: 'var(--text-secondary)',
              fontSize: 'clamp(1rem, 1.8vw, 1.125rem)',
              lineHeight: '1.8',
              paddingLeft: '24px',
              margin: 0
            }}>
              <li>Clear check-in & check-out instructions</li>
              <li>Interactive house rules and safety tips</li>
              <li>Local area guides and restaurant recommendations</li>
              <li>24/7 host contact & support information</li>
              <li>Easy navigation on mobile and desktop</li>
            </ul>
          )
        }
      ]
    },

    // ⚙️ PROCESS
    {
      id: 'process',
      title: 'Process',
      blocks: [
        {
          type: 'text',
          content: 'Built with a focus on UX and clarity, using React and Next.js for fast performance and seamless navigation. Design iterations were informed by guest feedback to ensure every visitor feels welcome and well-informed.',
          size: 'normal',
          align: 'left'
        }
      ]
    }
  ],

  // 🎯 CALL TO ACTION
  callToAction: {
    title: 'Book Your Stay',
    text: 'Visit our Airbnb listing and reserve your next getaway',
    button: {
      text: 'View on Airbnb →',
      url: 'https://www.airbnb.com/'
    }
  }
};
